export interface Transaction {
  id: string;
  name: string;
  amount: number;
  date: string;
  type: 'income' | 'expense' | 'transfer';
  // Plaid API fields (for future integration)
  plaidTransactionId?: string;
  merchantName?: string;
  pending?: boolean;
}

export interface MonthSummary {
  month: string;
  transactionCount: number;
  moneyIn: number;
  moneyOut: number;
  netChange: number;
}

export type Category = 'Save' | 'Needs' | 'Wants' | 'Debt';
export type NeedsSubcategory = 'Housing' | 'Food' | 'Transportation' | 'Self Care';
export type FeelingScore = 1 | 2 | 3 | 4 | 5;

export interface CategorizedTransaction {
  transactionId: string;
  category: Category;
  subcategory?: NeedsSubcategory;
  feelingScore: FeelingScore;
  amount: number;
  date: string;
  name: string;
}

export interface CategoryBreakdown {
  category: string;
  amount: number;
  averageFeeling: number;
}

export interface SpendingProfile {
  totalSpending: number;
  overallScore: number;
  categoryBreakdowns: CategoryBreakdown[];
  needsBreakdown: CategoryBreakdown[];
}

export const FEELING_LABELS: Record<FeelingScore, string> = {
  1: 'Extreme TW',
  2: 'TW',
  3: 'Neutral',
  4: 'ST',
  5: 'Extreme ST',
};

export const FEELING_EMOJIS: Record<FeelingScore, string> = {
  1: '😭',
  2: '😟',
  3: '😐',
  4: '😊',
  5: '😍',
};

export interface UserProfile {
  uid: string;
  email: string;
  firstName: string;
  lastName: string;
  createdAt: Date;
  hasConnectedAccounts: boolean;
}
